<template>
    <a-modal id="ConfirmModal" :footer="null" :closable="false" :header="null" :visible="true" width="600px">
        <div class="delete-modal-cancel" @click="handleCancel">
            <span class="md-icon" style="color: #ec4b1d; cursor: pointer">cancel</span>
        </div>
        <div class="delete-modal-image">
            <ConfirmModalIcon style="width: 300px; max-height: 150px" />
        </div>
        <div class="delete-modal-text">{{ description }}</div>

        <div class="task-status-form">
            <div class="status-buttons">
                <button
                    class="status-button"
                    :class="{ active: status === 'Won' }"
                    @click="selectStatus('Won')"
                >
                    <span class="material-icons">emoji_events</span>
                    <span>Won</span>
                </button>
                <button
                    class="status-button"
                    :class="{ active: status === 'Lost' }"
                    @click="selectStatus('Lost')"
                >
                    <span class="material-icons">cancel</span>
                    <span>Lost</span>
                </button>
                <button
                    class="status-button"
                    :class="{ active: status === 'Paused' }"
                    @click="selectStatus('Paused')"
                >
                    <span class="material-icons">pause_circle</span>
                    <span>Paused</span>
                </button>
            </div>

            <transition name="fade">
                <div v-if="status" class="description-area">
                    <label>Açıklama</label>
                    <a-textarea
                        v-model="statusDescription"
                        :rows="3"
                        placeholder="Durum ile ilgili açıklama giriniz..."
                    />
                </div>
            </transition>
        </div>

        <div class="delete-modal-slot">
            <slot></slot>
        </div>

        <div class="modal-actions" v-if="modalBtnVisible">
            <button class="cancel-button" @click="handleCancel">
                {{ btnCancelText }}
            </button>
            <button class="confirm-button" @click="handleConfirm" :disabled="!status">
                {{ btnoktext }}
            </button>
        </div>
    </a-modal>
</template>

<script>
import ConfirmModalIcon from "../../Chatbot/pages/integrations/svg/ConfirmModalIcon.vue";

export default {
    name: "ConfirmModal",
    components: { ConfirmModalIcon },
    data() {
        return {
            status: "",
            statusDescription: ""
        };
    },
    props: {
        description: {
            type: String,
            default: "",
        },
        btnoktext: {
            type: String,
            default: "Onayla",
        },
        btnCancelText: {
            type: String,
            default: "İptal",
        },
        modalBtnVisible: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        handleCancel() {
            this.$emit("cancel");
        },
        handleConfirm() {
            if (!this.status) return;

            this.$emit("confirm", {
                status: this.status,
                description: this.statusDescription
            });
        },
        selectStatus(status) {
            this.status = status;
        }
    },
};
</script>

<style scoped lang="scss">
#ConfirmModal {
    .delete-modal-cancel {
        float: inline-end;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        height: 30px;
        margin-top: -10px;
    }

    .delete-modal-image {
        display: flex;
        justify-content: center;
        margin-bottom: 20px;
    }

    .delete-modal-text {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        font-weight: 500;
        color: #181c32;
        margin-bottom: 25px;
        text-align: center;
    }

    .task-status-form {
        padding: 0 20px;
        margin-bottom: 20px;

        .status-buttons {
            display: flex;
            justify-content: center;
            gap: 15px;
            margin-bottom: 20px;

            .status-button {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                padding: 15px 25px;
                border: 2px solid #e6e9f2;
                border-radius: 8px;
                background: white;
                cursor: pointer;
                transition: all 0.2s ease;
                min-width: 120px;

                .material-icons {
                    font-size: 24px;
                    margin-bottom: 8px;
                    color: #ec4b1d;
                }

                span:not(.material-icons) {
                    font-weight: 500;
                    color: #55555a;
                }

                &:hover {
                    border-color: #ec4b1d;
                    background: #fff8f6;

                    .material-icons {
                        color: #ec4b1d;
                    }

                    span:not(.material-icons) {
                        color: #ec4b1d;
                    }
                }

                &.active {
                    border-color: #ec4b1d;
                    background: #fff8f6;

                    .material-icons {
                        color: #ec4b1d;
                    }

                    span:not(.material-icons) {
                        color: #ec4b1d;
                    }
                }

                &[class*="Won"], &[class*="Lost"], &[class*="Paused"] {
                    &:hover, &.active {
                        border-color: #ec4b1d;
                        .material-icons { color: #ec4b1d; }
                        span:not(.material-icons) { color: #ec4b1d; }
                        background: #fff8f6;
                    }
                }
            }
        }

        .description-area {
            margin-top: 20px;

            label {
                display: block;
                margin-bottom: 8px;
                font-weight: 500;
                color: #181c32;
            }

            :deep(.ant-input) {
                border-radius: 8px;
                border: 2px solid #e6e9f2;

                &:focus {
                    border-color: #1890ff;
                    box-shadow: none;
                }
            }
        }
    }

    .modal-actions {
        display: flex;
        justify-content: center;
        gap: 15px;
        margin-top: 20px;

        button {
            padding: 10px 25px;
            border-radius: 6px;
            font-weight: 500;
            font-size: 14px;
            cursor: pointer;
            transition: all 0.2s ease;
        }

        .cancel-button {
            background: transparent;
            border: 2px solid #e6e9f2;
            color: #55555a;

            &:hover {
                border-color: #ec4b1d;
                color: #ec4b1d;
                background: #fff8f6;
            }
        }

        .confirm-button {
            background: #ec4b1d;
            border: none;
            color: white;

            &:hover {
                background: #d64419;
            }

            &:disabled {
                background: #ffc5b8;
                cursor: not-allowed;
            }
        }
    }
}

.fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from, .fade-leave-to {
    opacity: 0;
}
</style>
